import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import DatePicker from "react-datepicker";
import SchemeReportMiddleware from "../../store/prat_middleware/schemeReport/schemeReportMiddleware";
import "./schemeReport.styles.scss";
import CustomToast from "../../util-functions/customToast.jsx";

class SchemeReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateFrom: "",
      dateTo: "",
      currentDate: "",
      is_invoice_on: true,
    };
  }

  componentDidMount() {
    let myCurrentDate = new Date();
    this.setState({
      currentDate: myCurrentDate,
    });
  }

  handleDateFromChange = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        dateFrom: selectedValue,
        dateTo: "",
      });
    } else {
      this.setState({
        dateFrom: "",
        dateTo: "",
      });
    }
  };

  handleDateToChange = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        dateTo: selectedValue,
      });
    } else {
      this.setState({
        dateTo: "",
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  dateFormate = (value) => {
    var d = new Date(value);
    let year = d.getFullYear();
    let month = d.getMonth();
    let day = d.getDate();

    return year + "-" + (month + 1) + "-" + day;
  };

  handleDownloadXlsxFile = () => {
    console.log(this.state.dateFrom);
    console.log(this.state.dateTo);
    console.log(this.state.is_invoice_on);
    if (this.state.dateFrom && this.state.dateTo) {
      let selectedDateFrom = this.dateFormate(this.state.dateFrom);
      let selectedDateTo = this.dateFormate(this.state.dateTo);

      this.props.downloadSchemeReport(
        this.state.is_invoice_on,
        selectedDateFrom,
        selectedDateTo
      );
    } else {
      // ToastsStore.error('Date is not selected!')
      CustomToast("error", "Date is not selected!");
    }
  };

  handleChangeInvoice = () => {
    console.log("toggle");
    this.setState({ is_invoice_on: !this.state.is_invoice_on });
  };

  render() {
    return (
      <div className="page-container">
        <div className="heading-and-download-container">
          <span className="component-heading">Scheme Report</span>

          {this.props.isFileDownloading ? (
            <img
              alt=""
              style={{ width: "26px", height: "31px" }}
              src={require("../../assets/gifs/Downloading.gif")}
            />
          ) : (
            <img
              alt=""
              style={{ cursor: "pointer" }}
              src={require("../../assets/images/downloadIcon.svg")}
              onClick={this.handleDownloadXlsxFile}
            />
          )}
        </div>

        {/* <div className='select-download-container'> */}

        <div className="select-container">
          <div className="date-component-container filters-container-only">
            <DatePicker
              selected={this.state.dateFrom}
              isClearable={this.state.dateFrom ? true : false}
              // minDate={this.state.currentDate ? this.state.currentDate : ''}
              onChange={this.handleDateFromChange} //only when value has changed
              placeholderText="Date Start From"
              className="date-from"
            />

            <DatePicker
              selected={this.state.dateTo}
              isClearable={this.state.dateTo ? true : false}
              minDate={this.state.dateFrom ? this.state.dateFrom : ""}
              disabled={this.state.dateFrom ? false : true}
              onChange={this.handleDateToChange} //only when value has changed
              placeholderText="Date Start To"
              className="date-to"
            />
            <div style={{
              display:"flex",
              margin:'0px 10px'
            }}>
              <p style={{
                    margin: '5px',
                    fontWeight: '600'
              }}>Off</p>
              <div className="invoice-toggle">
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={this.state.is_invoice_on}
                    onChange={this.handleChangeInvoice}
                  />
                  <span className="switch" />
                </label>
              </div>
              <p style={{ margin: '5px',
                    fontWeight: '600'}}>On</p>
            </div>
          </div>

          <Button
            style={{ marginBottom: "16px", width: "136px" }}
            variant="outlined"
            className="submit-btn"
            onClick={(e) => this.handleSubmit(e)}
          >
            SUBMIT
          </Button>
        </div>

        {/* </div> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isFileDownloading: state.DownloadXlxReducer.isFileDownloading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    downloadSchemeReport: (is_invoice_on, dateFrom, dateTo) => {
      return dispatch(
        SchemeReportMiddleware.downloadSchemeReport(
          is_invoice_on,
          dateFrom,
          dateTo
        )
      );
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SchemeReport);
